<template>
  <div>
    <div class="page_title">用户权益管理</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="flex between">
          <div class="searchbox">
            <div>用户权益名称：</div>
            <el-input
              v-model="preferential_name"
              style="width:180px;margin:0 10px"
              clearable
            />
            <div>用户分群：</div>
            <el-input
              v-model="label_name"
              style="width:180px;margin:0 10px"
              clearable
            />
            <el-button
              @click="search"
              type="info"
              style="background-color:#eceff2;;color:#747981;"
              >查询</el-button
            >
          </div>
          <el-button
            type="primary"
            @click="addActivity"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1518') : false
            "
            >新增权益</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column prop="preferential_name" label="用户权益名称" />
            <el-table-column prop="label_name" label="用户分群" />
            <el-table-column prop="discount" label="权益折扣" />
            <el-table-column label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 1">启用</div>
                <div v-if="scope.row.status == 0">关闭</div>
              </template>
            </el-table-column>
            <el-table-column prop="update_time" label="更新时间" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="edit(scope.row.preferential_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1526')
                      : false
                  "
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [{}],
      preferential_name: "",
      label_name: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        preferential_name: this.preferential_name,
        label_name: this.label_name,
        page: this.currentPage,
        pageNumber: this.pagesize,
      };
      console.log("data", data);
      this.axios.post("platform/Userpreferential/getList", data).then((res) => {
        let list = res.data.list.map((item) => {
          item.update_time = dayjs
            .unix(item.update_time)
            .format("YYYY-MM-DD HH:mm:ss");
          return item;
        });
        this.totalNum = res.data.total;
        this.tableData = list;
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    addActivity() {
      this.$router.push({
        path: "userRightsSet",
        query: {
          isAdd: 1,
        },
      });
    },
    edit(preferential_id) {
      this.$router.push({
        path: "userRightsSet",
        query: {
          isAdd: 0,
          preferential_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
